import React from 'react'

import { COLOR, NATIVE_BASE_COLORS } from '../../../../themes'
import { connect } from 'react-redux'

import { OrderManagerTabStyle } from './styles'

function OrderManagerTab(props) {
  const {
    colorTheme,
    orderManagerTab,
    language,
    setSelectedTab,
    selectedTab,
  } = props

  const borderBottomLineStyle = (value) => {
    return ({
      backgroundColor: (selectedTab === value) && colorTheme 
        ? colorTheme.MAIN
        : COLOR.TRANSPARENCY,
      width: '100%',
      height: '3px',
      position: 'absolute',
      transform: 'translateY(13px)',
      borderRadius: '8px 8px 0 0',
      zIndex: '3',
    })
  }

  const tabStyle = (value) => {
    return ({
      color: selectedTab !== value && NATIVE_BASE_COLORS.TEXT[400],
    })
  }

  return (
    <OrderManagerTabStyle>
      {Object.values(orderManagerTab).map(({ value, title }) => {
        return (
          <div className='order-manager__tab' key={value}>
            <label
              className='order-manager__tab__item'
              htmlFor={value}
              style={tabStyle(value)}
            >
              {title[language]}
            </label>
            <input
              className='order-manager__tab__input'
              type='radio'
              id={value}
              name='orderManagerTab'
              value={value}
              onChange={(event) => setSelectedTab(event.target.value)}
            />
            <div style={borderBottomLineStyle(value)} />
          </div>
        )
      })}
    </OrderManagerTabStyle>
  )
}

const mapStateToProps = ({ accountReducer }) => {
  return {
    colorTheme: accountReducer.user.colorThemePalette,
  }
}

export default connect(mapStateToProps, null)(OrderManagerTab)
